export function isTouchDevice(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    return window.matchMedia?.('(hover: none) and (pointer: coarse)')?.matches;
}

export function isMac(): boolean {
    return window.navigator.platform === 'MacIntel';
}

export function isWindows(): boolean {
    return window.navigator.platform === 'Win32';
}
